import { SVGProps, Ref, forwardRef } from 'react';

export const CompanysLifeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M7.032 7.332c0 .098.038.209.143.32.158.168.45.313.823.313s.665-.145.823-.313a.47.47 0 0 0 .143-.32h1.4c0 .501-.209.944-.523 1.278-.45.48-1.126.755-1.843.755S6.605 9.09 6.154 8.61a1.86 1.86 0 0 1-.522-1.278z"
                    fill="currentColor"
                />
                <path
                    d="M4.677 3.633c.205-.246.527-.4.988-.4.462 0 .784.154.988.4.202.242.279.56.279.866s-.077.623-.279.866c-.204.245-.526.4-.988.4s-.783-.155-.988-.4c-.202-.243-.278-.56-.278-.866 0-.307.076-.624.278-.866"
                    fill="currentColor"
                />
                <path
                    d="M9.343 3.633c.204-.246.526-.4.988-.4s.783.154.988.4c.202.242.278.56.278.866s-.076.623-.278.866c-.205.245-.527.4-.988.4-.462 0-.784-.155-.988-.4-.202-.243-.279-.56-.279-.866 0-.307.077-.624.279-.866"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.754 11.399 8 15.5l3.247-4.101C14.797 11.266 16 9.84 16 5.955 16 1.864 14.667.5 10.667.5H5.333C1.333.5 0 1.864 0 5.955c0 3.886 1.203 5.311 4.754 5.444M8 13.245l-2.55-3.221L4.806 10c-1.644-.062-2.342-.417-2.703-.833C1.706 8.71 1.4 7.826 1.4 5.955c0-1.974.34-2.846.768-3.283.418-.428 1.249-.772 3.165-.772h5.334c1.916 0 2.747.344 3.165.772.428.437.768 1.31.768 3.283 0 1.87-.306 2.754-.703 3.212-.36.416-1.058.771-2.701.833l-.645.024z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
CompanysLifeOutlinedSize16Glyph.displayName = 'CompanysLifeOutlinedSize16Glyph';
